// extracted by mini-css-extract-plugin
export default {"root":"styles_root__f7w-u","root--contacts":"styles_root--contacts__iQpua","title":"styles_title__y+L1S"};